var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.subset)?_c('b',[_vm._v(_vm._s(_vm.subset))]):_vm._e(),_c('b-table',{staticClass:"mb-0",attrs:{"items":_vm.tableData,"fields":_vm.columns,"responsive":"","bordered":"","striped":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }